import gettext from '@sdk/lang/gettext';
import { SUBSCRIPTION_NAMES } from '@sdk/common/constants';
import { SubscriptionPlanNames } from '@sdk/account/types';

export function getSubmitButtonText(
  showFeaturesToLose: boolean,
  isDowngradeOnly: boolean,
  subscriptionLevel: number,
  isOldPremium: boolean
) {
  let submitButtonText = '';
  if (showFeaturesToLose) {
    submitButtonText = isDowngradeOnly ? gettext('Downgrade anyway') : gettext('Cancel anyway');
  } else {
    submitButtonText = isDowngradeOnly
      ? gettext('Downgrade to Premium')
      : gettext('Cancel %(subscriptionName)s', {
          subscriptionName: isOldPremium
            ? SubscriptionPlanNames.premium
            : SUBSCRIPTION_NAMES[subscriptionLevel],
        });
  }

  return submitButtonText;
}
